import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { MaterializeAction, MaterializeDirective, toast } from 'angular2-materialize';
import { ActivatedRoute } from '@angular/router';
import { Utils } from '../../util';

import { OutcomeService, OutcomeData, OutcomedBill, OutcomeBill, Outcome } from '../../services/outcome.service';
import { SupplierBillService, SupplierBillData, ChargeNote, Outcomed, SupplierBill, SupplierBillId } from '../../services/supplier-bill.service';
import { CustomerSupplierService } from '../../services/customer-supplier.service';
import { FiscalDataService } from '../../services/fiscal-data.service';
import { BankService, BankData } from '../../services/bank.service';

import { ISubscription, Subscription } from "rxjs/Subscription";

@Component({
  selector: 'app-display-outcome',
  templateUrl: './display-outcome.component.html',
  styleUrls: ['./display-outcome.component.css']
})
export class DisplayOutcomeComponent implements OnInit, OnDestroy {

  outcomeId: string;
  supplierName: string = '';
  fiscalDataName: string = '';

  form: FormGroup;

  subs = [];

  constructor(
    private service: OutcomeService,
    private outcomeData: OutcomeData,
    private supplierBillService: SupplierBillService,
    private supplierBillData: SupplierBillData,
    private supplierService: CustomerSupplierService,
		private fiscalDataService: FiscalDataService,
    private bankService: BankService,
    private bankData: BankData,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder
  ) {
    this.outcomeId = activatedRoute.snapshot.paramMap.get('id');

    this.subs.push(
      this.supplierBillService.getSupplierBills().subscribe(supplierBills => {
        this.outcomedBills = supplierBills.map(supplierBill => new OutcomedBill(supplierBill, this.outcomeId) ).filter(bill => bill.lastAmount);
      })
    );
  }

  ngOnInit() {
    this.createForm();
    this.subs.push(
      this.service.getOutcome(this.outcomeId).subscribe(([outcome]) => {
        outcome.payMethod = this.outcomeData.statusObjects[outcome.payMethod].name;
        this.form.patchValue(outcome);
        this.selectedBankAccountNumber = outcome.bankObj.accountNumber;
        this.supplierName = outcome.supplierObj.name;
        this.fiscalDataName = outcome.fiscalDataObj.businessName;  
      })
    );
  }
	ngOnDestroy() {
    this.subs.map((sub,index) => {
      this.subs[index].unsubscribe();
    });
  }

  createForm(){
    this.form = this.fb.group({
      date: '',
      amount: '',
      payMethod: '',
      notes: ''
    });
  }

  money = Utils.money;

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA 
  selectedBankAccountNumber: string = '';
  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA

  //////////////////////////////////////////////////////////////////////////////////////////////CUSTOMER BILL
  outcomedBills: OutcomedBill[] = [];
  //////////////////////////////////////////////////////////////////////////////////////////////CUSTOMER BILL
}